module.exports = __webpack_public_path__ + "img/upload_wall_5.504ecddb.webp";